/* eslint-disable camelcase */
import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn,
  OneToOne, JoinColumn, OneToMany, ManyToOne, AfterInsert, AfterUpdate, getManager,
  Not, BeforeRemove, AfterRemove,
} from 'typeorm';
import {
  IsOptional, IsBoolean, IsInt, IsString,
} from 'class-validator';
import {
  SexoBebe, DppFinal, Acompanhamento,
} from '../types';
import { Paciente } from './Paciente';
import { Consulta } from './Consulta';
import { Vacinacao } from './Vacinacao';
import { ResultadoDeExame } from './ResultadoDeExame';
import { Usuario } from './Usuario';
import { MedicaoGlicemia } from './MedicaoGlicemia';
import { Parto } from './Parto';
import { MedicaoPressaoArterial } from './MedicaoPressaoArterial';
import { NotaProntuario } from './NotaProntuario';
import { Ultrassom } from './Ultrassom';
import { Internacao } from './Internacao';

@Entity({ name: 'gestacoes' })
export class Gestacao {
  @AfterUpdate()
  @AfterInsert()
  @AfterRemove()
  async atualizaParidadePaciente?() {
    const pacienteRepo = await getManager().getRepository(Paciente);
    const gestacaoRepo = await getManager().getRepository(Gestacao);
    const gestacoes = await gestacaoRepo.find({
      where: {
        ...(this.id ? { id: Not(this.id) } : {}),
        paciente_id: this.paciente_id,
      },
      relations: ['parto'],
    });
    // com base nas gestacoes, conta o G
    const paridade = {
      G: 0, A: 0, C: 0, N: 0,
    };
    if (this.id) {
      // conta gestacao atual
      paridade.G += 1;
      // checa se gestacao criada/atualizada tem parto
      if (this.parto) {
        paridade[this.parto.tipo_parto] += 1;
      }
    }

    gestacoes.forEach((el) => {
      if (el.atual) {
        paridade.G += 1;
      } else if (el.parto) {
        paridade.G += 1;
        paridade[el.parto.tipo_parto] += 1;
      }
    });

    if (paridade.G === 1 && paridade.A === 0 && paridade.C === 0 && paridade.N === 0) {
      if (!this.primeira_gestacao) {
        paridade.G = 0;
      }
    }
    let paridadeString = '';
    if (paridade.G) paridadeString = `${paridadeString}G${paridade.G}`;
    if (paridade.A) paridadeString = `${paridadeString}A${paridade.A}`;
    if (paridade.N) paridadeString = `${paridadeString}PN${paridade.N}`;
    if (paridade.C) paridadeString = `${paridadeString}C${paridade.C}`;
    await pacienteRepo.update({ id: this.paciente_id }, { paridade: paridadeString || null });
  }

  @BeforeRemove()
  async removeParto?() {
    const partoRepo = await getManager().getRepository(Parto);
    if (this.parto_id) {
      await partoRepo.delete({ id: this.parto_id });
    }
  }

  @PrimaryGeneratedColumn()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsInt()
  @IsOptional()
  parto_id?: number;

  @Column()
  @IsBoolean()
  @IsOptional()
  atual?: boolean;

  @Column()
  @IsBoolean()
  @IsOptional()
  gestacao_anterior?: boolean;

  @Column()
  @IsOptional()
  peso_inicial_gramas?: number | null;

  // GESTACAO
  @Column()
  @IsOptional()
  @IsBoolean()
  flag_dg?: boolean; // diabetes gestacional

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_pa?: boolean; // pressao arterial

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_rc?: boolean; // restricao de crescimento

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_ar?: boolean; // alto risco

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_hg?: boolean; // herpes genital

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_rh_negativo?: boolean;

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_ht?: boolean; // hipotireoidismo

  @Column()
  @IsOptional()
  @IsBoolean()
  flag_tf?: boolean; // trombofilia

  @Column()
  @IsOptional()
  @IsBoolean()
  primeira_gestacao?: boolean; // para cálculo da paridade

  @Column()
  @IsOptional()
  @IsBoolean()
  gestacao_solo?: boolean;

  @Column()
  @IsOptional()
  @IsBoolean()
  gestacao_gemelar?: boolean;

  @Column()
  @IsOptional()
  @IsString()
  gestacao_gemelar_obs?: string | null;

  @Column()
  @IsOptional()
  data_ultima_menstruacao?: Date | null;

  @Column()
  @IsOptional()
  data_provavel_parto?: Date | null;

  @Column()
  @IsOptional()
  ig_exame_us_dias?: number | null;

  @Column()
  @IsOptional()
  ig_semanas?: number | null;

  @Column()
  @IsOptional()
  ig_dias?: number | null;

  @Column()
  @IsOptional()
  data_exame_us?: Date | null;

  @Column()
  @IsOptional()
  data_provavel_parto_us?: Date | null;

  @Column({
    type: 'enum',
    enum: DppFinal,
  })
  @IsOptional()
  dpp_final: DppFinal | null;

  // @Column({
  //   type: 'enum',
  //   enum: TipoParto,
  // })
  // @IsOptional()
  // tipo_parto?: TipoParto | null;

  @Column()
  @IsOptional()
  medico?: string | null;

  @Column()
  @IsOptional()
  pediatra?: string | null;

  @Column()
  @IsOptional()
  doula?: string | null;

  @Column()
  @IsOptional()
  fotografa?: string | null;

  @Column()
  @IsOptional()
  local_parto?: string | null;

  // @Column()
  // @IsOptional()
  // observacoes?: string | null;

  @Column()
  @IsOptional()
  obs_pre_natal?: string | null;

  // BEBES
  @Column()
  @IsOptional()
  nome1?: string | null;

  @Column({
    type: 'enum',
    enum: SexoBebe,
  })
  @IsOptional()
  sexo1?: SexoBebe | null;

  // @Column()
  // @IsOptional()
  // peso1_gramas?: number | null;

  @Column()
  @IsOptional()
  nome2?: string | null;

  @Column({
    type: 'enum',
    enum: SexoBebe,
  })
  @IsOptional()
  sexo2?: SexoBebe | null;

  // @Column()
  // @IsOptional()
  // peso2_gramas?: number | null;

  // @Column()
  // @IsOptional()
  // data_parto?: Date | null;

  @Column()
  @IsOptional()
  responsavel_id?: number | null;

  // @Column()
  // @IsOptional()
  // laceracao?: number | null;

  // @Column()
  // @IsOptional()
  // sutura?: boolean | null;

  // @Column()
  // @IsOptional()
  // ocorrencia_hpp?: boolean | null;

  // @Column()
  // @IsOptional()
  // ocorrencia_induzido?: boolean | null;

  // @Column()
  // @IsOptional()
  // ocorrencia_analgesia?: boolean | null;

  // @Column()
  // @IsOptional()
  // ocorrencia_vacuo?: boolean | null;

  // @Column()
  // @IsOptional()
  // ocorrencia_forceps?: boolean | null;

  @Column({
    type: 'enum',
    enum: Acompanhamento,
  })
  @IsOptional()
  acompanhamento?: string | null;

  @Column()
  @IsOptional()
  datetime_triagem?: Date | null;

  @Column()
  @IsOptional()
  ended?: Date | null;

  @Column()
  @IsOptional()
  ended_by?: number | null;

  @CreateDateColumn()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @OneToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @OneToOne(() => Parto, {
    eager: true,
    cascade: ['update', 'insert'],
  })
  @JoinColumn({ name: 'parto_id' })
  parto?: Parto;

  @OneToMany(() => Consulta, (consulta) => consulta.gestacao, {
    // eager: true,
    cascade: ['insert', 'update'],
  })
  consultas?: Consulta[];

  @OneToMany(() => NotaProntuario, (nota_prontuario) => nota_prontuario.gestacao, {
    eager: false,
  })
  notas_prontuarios?: NotaProntuario[];

  @OneToMany(() => Ultrassom, (ultrassom) => ultrassom.gestacao, {
    eager: false,
  })
  ultrassons?: Ultrassom[];

  @OneToMany(() => Vacinacao, (vacinacao) => vacinacao.gestacao, { eager: true })
  vacinacoes?: Vacinacao[];

  @OneToMany(() => ResultadoDeExame, (resultados_de_exames) => resultados_de_exames.gestacao, {
    cascade: ['insert', 'update'],
  })
  resultados_de_exames?: ResultadoDeExame[];

  @OneToMany(() => MedicaoGlicemia, (medicao_glicemia) => medicao_glicemia.gestacao)
  medicoes_glicemia?: MedicaoGlicemia[];

  @OneToMany(() => Internacao, (internacao) => internacao.gestacao)
  internacoes?: Internacao[];

  @OneToMany(
    () => MedicaoPressaoArterial,
    (medicao_pressao_arterial) => medicao_pressao_arterial.gestacao,
  )
  medicoes_pressao_arterial?: MedicaoPressaoArterial[];

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'responsavel_id' })
  responsavel?: Usuario;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario)
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;
}
